export class Buttons {

    private items: Array<{
        name: string,
        text?: string,
        icon?: string,
        classes?: string,
        disabled: () => boolean,
        loader: () => boolean,
        callback: () => void,
    }> = [];

    /**
     * Add a new button.
     *
     * @param {string} name
     * @param options
     * @return {any & {name: string}}
     */
    public add(name: string, options: any = {}) {
        const index = this.items.findIndex((item) => {
            return item.name === name;
        });

        if (index >= 0) {
            return this.replace(name, options);
        }

        const item = Object.assign(options, {name: name});

        this.items.unshift(item);

        return item;
    }

    /**
     * Get the button with the given name.
     *
     * @param {string} name
     * @return {{name: string; text?: string; icon?: string; classes?: string; callback: (() => void)}}
     */
    public get(name: string) {
        return this.items.find((item) => {
            return item.name === name;
        });
    }

    /**
     * Remove the specified button.
     *
     * @param {string} name
     */
    public remove(name: string) {
        this.items = Array.from(this.items.filter((item: any) => {
            return item.name !== name;
        }));
    }

    /**
     * Replace the specified button with a new button.
     *
     * @param {string} name
     * @param options
     * @return {any & {name: string}}
     */
    public replace(name: string, options: any = {}) {
        const index = this.items.findIndex((item) => {
            return item.name === name;
        });

        const item = Object.assign(options, {name: name});

        this.items.splice(index, 1, item);

        return item;
    }

    /**
     * Update `properties` of the `name` button.
     *
     * @param name - The button name.
     * @param properties - The properties to be updated.
     */
    public update(name: string, properties: { [key: string]: any } = {}) {
        const item = this.get(name);

        if (item) {
            Object.assign(item, properties);
        }
    }

    /**
     * Insert a new button before the specified button.
     *
     * @param {string} before
     * @param {string} name
     * @param options
     */
    public before(before: string, name: string, options: any = {}) {
        const index = this.items.findIndex((item) => {
            return item.name === before;
        });

        const item = Object.assign(options, {name: name});

        this.items.splice(index, 0, item);
    }

    /**
     * Add a button at the beginning of the buttons list.
     *
     * @param name
     * @param options
     */
    public prepend(name: string, options: any = {}) {
        const item = Object.assign(options, {name: name});

        this.items.push(item);

        return item;
    }

    /**
     * Insert a new button after the specified button.
     *
     * @param {string} after
     * @param {string} name
     * @param options
     */
    public after(after: string, name: string, options: any = {}) {
        const index = this.items.findIndex((item) => {
            return item.name === after;
        });

        const item = Object.assign(options, {name: name});

        this.items.splice(index - 1, 0, item);
    }

    public all() {
        return this.items;
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/modals/classes/buttons.ts